import { all } from '@/api/post';
import * as types from './types'

const state = {
  loading: false,
  posts: [],
  searched: false,
  page: 1,
  pagination: {
    total: 0,
    totalPages: 0,
  },
  ready: false,
  form: {
    role_id: null,
    region_id: null,
  },
};

const getters = {
  loading: (state) => state.loading,
  posts: (state) => state.posts,
  searched: (state) => state.searched,
  pagination: (state) => state.pagination,
  page: (state) => state.page,
  ready: (state) => state.ready,
  form: (state) => state.form,
};

const actions = {
  async fetch({ commit }, { form, search = null, pagination = {} }) {
    try {
      commit(types.FETCHING);
      commit(types.FETCHED, await all(form, search, pagination));
    } catch (e) {
      console.log(e);
    } finally {
      commit(types.DONE);
      commit(types.READYED);
    }
  },
  pageChange({ commit }, page) {
    commit(types.PAGE_CHANGED, page);
  },
  ready({ commit }) {
    commit(types.READYED);
  },
  reset({ commit }) {
    commit(types.RESET);
  }
};

const mutations = {
  [types.FETCHING](state) {
    state.loading = true;
  },
  [types.DONE](state) {
    state.loading = false;
  },
  [types.FETCHED](state, { data, pagination }) {
    state.posts = data;
    state.searched = true;
    Object.assign(state.pagination, {
      total: pagination.total,
      totalPages: pagination.totalPages,
    });
  },
  [types.PAGE_CHANGED](state, page) {
    state.page = page;
  },
  [types.READYED](state) {
    state.ready = true;
  },
  [types.RESET](state) {
    Object.assign(state, {
      posts: [],
      searched: false,
      pagination: {
        total: 0,
        totalPages: 0,
      },
      ready: true,
    })
  },
  updateForm(state, form) {
    state.form = form;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
